import oCorpoAbertoPoster from '../images/filmes/ocorpoaberto.jpg';
import nenaPoster from '../images/filmes/nena.jpg';
import retratosFantasmasPoster from '../images/filmes/retratosfantasmas.jpg';
import aMeninaEoPotePoster from '../images/filmes/ameninaeopote.jpg';
import nomePoster from '../images/filmes/nome.jpg';
import primaKuLebsiPoster from '../images/filmes/primakulebsi.jpg';
import cesariaEvoraPoster from '../images/filmes/cesariaevora.jpg';
import percebesPoster from '../images/filmes/percebes.jpg';

const createFilm = (titulo, director, ano, duracion, xenero, pais, premios, trailer, sinopse, poster) => ({
  titulo,
  director,
  ano,
  duracion,
  xenero,
  pais,
  premios,
  trailer,
  sinopse,
  poster,
});

export const oCorpoAberto = createFilm(
  "O corpo aberto",
  "Ángeles Huerta",
  2022,
  91,
  "Terror, Drama",
  "Galicia",
  [
    "2023: MOTELX, Festival Internacional de Cinema de Terror em Lisboa – Meliès d’argent",
    "2023: Festival de Gijón – Sección Esbilla",
    "2023: 12 Premios Mestre Mateo",
    "2023: Festival de Valladolid – SEMINCI – Sección Oficial"
  ],
  "https://www.youtube.com/watch?v=Mxz2NHZEq2k",
  "1909. Miguel, un novo profesor, é destinado a unha pequena aldea de montaña na fronteira entre España e Portugal: Lobosandaus, unha aldea inhóspita de tradicións ancestrais. É un home de razón, pero non pode controlar os seus desexos pasionais e, conforme se achega o inverno, sente como a escuridade se apodera de todo ao seu redor á vez que crece a súa fascinación pola enigmática Dorinda. Nun lugar dominado pola superstición, a estraña morte dun veciño da aldea libera un espírito libre en busca dun corpo que lle permita seguir coa súa existencia, que levará a Miguel a cuestionar os límites entre o mundo dos vivos e dos mortos.",
  oCorpoAbertoPoster
);

export const nena = createFilm(
  "Nena",
  "Xosé A. Touriñán e Jairo Iglesias",
  2023,
  18,
  "Comedia, Drama",
  "Galicia",
  [
    "2024: Certame de Curtametraxes El Pecado. Premio do Xurado",
    "2024: Festival de Cine Curto de Ribadeo. Premio do Público",
    "2024: Fiv Vilafamés. Primeiro Premio",
    "2024: Festival de Cinema de Galapán. Mención especial",
    "2024: Mostra de Curtas Vila de Noia. Premio Blog español para Mellor Curta española",
  ],
  "https://www.youtube.com/watch?v=Mxz2NHZEq2k",
  "Unha familia de cinco membros tambaléase tras a morte da nai, esposa, nora, cuñada... Unha situación que rompe o núcleo familiar e deixa a responsabilidade do mesmo a unha nena de doce anos. Un avó máis preocupado polo diñeiro que polo afecto. Un tío cun gran corazón de neno, pero cunha discapacidade intelectual. Un pai esnaquizado polo loito e refuxiado na bebida. Unha nena que ante a falta de capacidades ao seu redor, asume un rol imposto e leva ás súas costas a supervivencia de tres homes.",
  nenaPoster
);

export const retratosFantasmas = createFilm(
  "Retratos fantasmas",
  "Kleber Mendoça Filho",
  2023,
  93,
  "Documental",
  "Brasil",
  [
    "2023: 76º Festival de Cannes – Special Screening",
    "2023: 70th Sydney Film Festival, (Australia)",
    "2023: 40th Munich Film Festival, (Alemaña)",
    "2023: New Zealand International Film Festival – Auckland, (Nova Zelandia)",
    "2023: Santiago Festival Internacional de Cine, (Chile)",
    "2023: New York Film Festival, (EUA) – US Premiere",
    "2023: 51º Festival de Cinema de Gramado, (Brasil) – Filme de Abertura",
    "2023: Melbourne International Film Festival, (Australia) – Documentaries section",
    "2023: 31º Festival de Curtas de Vila do Conde, (Portugal) – Sesión de Encerramento",
    "2023: Lima International Film Festival, (Perú) – LATIN AMERICA PREMIERE – Competición Documental",
    "2023: Toronto International Film Festival – TIFF, (Canadá) – Wavelength Programme – North America Premiere",
  ],
  "https://www.youtube.com/watch?v=_s3uhqB6nEo",
  "\"Retratos fantasmas\" é unha viaxe multidimensional a través do tempo, o son, a arquitectura e o cinema, ambientada na paisaxe urbana de Recife, capital costeira brasileira de Pernambuco: un territorio histórico e humano, examinado a través das grandes salas de cine que serviron como espazos de convivencia durante o século XX",
  retratosFantasmasPoster
);

export const aMeninaEoPote = createFilm(
  "A meniña e o pote",
  "Valentina Homen",
  2024,
  12,
  "Animación",
  "Brasil",
  [
    "2024: Cannes Festival 2024 – Critic's Week (World Premiere)",
    "2024: Annecy Festival – Perspectives",
    "2024: Bucheon International Animation Festival – Competition",
    "2024: São Paulo International Short Film Festival – Curta Kinoforum",
    "2024: Primanima World Festival of First Animations – Silhouettes Competition",
    "2024: Vitacura International Short Film Festival, Vitafest – Competition",
    "2024: Pianeta Mare Film Festival",
    "2024: CineAlter: Festival de Cinema de Alter do Chão",
    "2024: Latin Film Fest – Kino Muranów (Varsovia), Kino Nowe Horyzonty (Wrocław)",
  ],
  "https://www.youtube.com/watch?v=zfkf2ERRWKs",
  "Nun mundo distópico, unha nena rompe a súa vaixela de cerámica que garda un segredo no seu interior. A rotura da vasilla abre portais a un universo paralelo e ela entra nun momento de transformación no que é posible a creación dun mundo novo.",
  aMeninaEoPotePoster
);

export const nome = createFilm(
  "Nome",
  "Sana Na N'hada",
  2023,
  117,
  "Drama",
  "Guinea-Bissau",
  [
    "2024: Indie Lisboa 2024 | Sección Rizoma",
    "2023: ACID – Association du cinema independente pour la Difusion – Cannes",
    "2023: Festival International du Film Independant de Bordeaux | Grande Premio da Competición Internacional e mención especial para a actriz Binete Undonque",
    "2024: IFFR – International Film Festival Rotterdam | sección Harbour",
    "2023: Du Grain à Démoudre | Premio de Mellor Longametraxe",
    "2023: Luanda PAFF – Festival Internacional de Cinema Panafricano de Luanda: Premio de Mellor Film, Premio de Mellor Realización e Premio de Mellor Actriz para Binete Undonque",
  ],
  "https://vimeo.com/827438386",
  "É o ano 1969 e en plena Guerra Colonial Portuguesa en Guinea-Bissau. Pero antes de mergullarnos no conflito, vemos o día a día do protagonista, Nome, as súas relacións coa súa nai e a muller da que está namorado. Pero Nome non permanecerá moito máis tempo na aldea e entregarase en corpo e alma á loita armada coa guerrilla do PAIGC (Partido Africano para a Independencia de Guinea e Cabo Verde). Convértese nun heroe atormentado por todo o sucedido.",
  nomePoster
);

export const primaKuLebsi = createFilm(
  "Prima ku Lebsi",
  "Welket Bungué",
  2024,
  25,
  "Drama",
  "Guinea-Bissau",
  [],
  "https://www.youtube.com/watch?v=YsxTuha_AqE",
  "Prima e Lebsi son novas soñadoras nadas na gran Lisboa. Unha inesperada historia de amor entrelázaas, revelando un estilo de vida que involucra relacións paralelas con persoas e crenzas. Nun ambiente cheo de contradicións e desexos, emerxe o hedonismo como motor deste romance lésbico e urbano, rítmico pola música e a liberdade de corpos.",
  primaKuLebsiPoster
);

export const cesariaEvora = createFilm(
  "Cesária Évora",
  "Ana Sofia Fonseca",
  2022,
  94,
  "Documental",
  "Portugal",
  [
    "2022: SXSW Film Festival | Selección Oficial",
    "2023: Transilvania International Film Festival| Selección Oficial",
    "2023: Vancouver International Film Festival | Selección Oficial",
    "2022: IndieLisboa International Independent Film Festival | Gañadora: Audience Award (Feature Film)",
    "2022: Jeonju International Film Festival | Selección Oficial",
    "2022: Sheffield International Documentary Festival | Selección Oficial",
    "2023: DocsBarcelona | Selección Oficial",
  ],
  "https://www.youtube.com/watch?v=hMvD_KX84GY",
  "A cantante de renome mundial gañadora do premio Grammy Cesária Évora de Cabo Verde nun documental novo e íntimo. Con imaxes inéditas e información sobre a vida da cantante, a película segue as loitas e o éxito da diva descalza.",
  cesariaEvoraPoster
);

export const percebes = createFilm(
  "Percebes",
  "Laura Gonçalves, Alexandra Ramires (Xá)",
  2024,
  11,
  "Animación",
  "Portugal",
  [
    "2024: Festival de Annecy: Cristal de Annecy: Mellor curtametraxe",
  ],
  "https://www.youtube.com/watch?v=_1sC2vcUH1o",
  "Co mar e o Algarve urbano como pano de fondo, seguimos un ciclo vital completo dun molusco moi especial chamado percebes.",
  percebesPoster
);

export const filmes = [
  oCorpoAberto,
  nena,
  retratosFantasmas,
  aMeninaEoPote,
  nome,
  primaKuLebsi,
  cesariaEvora,
  percebes,
];